module.exports = __webpack_public_path__ + "coins.svg?25ec8491b1dcf9f96e3b9882eee99856";


//////////////////
// WEBPACK FOOTER
// ./src/img/coins.svg
// module id = 95
// module chunks = 0